import { Routes } from '@app/constants/routes';

import { ERole, ETeamMemberRole } from '@app/swagger-types';
import { MyRouteObject } from '@app/models/router';
import { TypedNavigate } from '@app/router';
import { CustomerModule } from './CustomerModule';
import { CustomerDashboardPage } from './pages/dashboard/CustomerDashboardPage';
import { MyQrCodesPage } from './pages/my-qr-codes/MyQrCodes.page';
import { Templates } from './pages/templates/Templates.page';
import { HelpPage } from './pages/help/HelpPage';
import { CreateTemplatePage } from './pages/templates/CreateTemplate.page';
import { EditTemplatePage } from './pages/templates/EditTemplate.page';
import { CreateQRCodePage } from './pages/create-qr-code/CreateQRCode.page';
import { MyQRCodeEditPage } from './pages/my-qr-codes/MyQRCodeEdit.page';
import { AccountModule } from './pages/account/AccountModule';
import { AccountSettingsPage } from './pages/account/AccountSettings.page';
import { AccountSubscriptionPage } from './pages/account/AccountSubscription.page';
import { AccountSuccessPaymentPage } from './pages/account/AccountSuccessPaymentPage';
import { AccountBillingPage } from './pages/account/AccountBillingPage';
import { AnalyticsPage } from './pages/analytics/AnalyticsPage';
import { AccountAPIKeysPage } from './pages/account/AccountAPIKeys.page';
import { AccountWhiteLabelPage } from './pages/account/AccountWhiteLabel.page';
import { AccountTeam } from './pages/account/AccountTeam.page';

const ownerOnlyRoutes: Array<MyRouteObject> = [
  {
    path: Routes.customer.account.subscription,
    element: <AccountSubscriptionPage />,
    teamMemberRole: [ETeamMemberRole.OWNER],
  },
  {
    path: Routes.customer.account.billing,
    element: <AccountBillingPage />,
    teamMemberRole: [ETeamMemberRole.OWNER],
  },
  {
    path: Routes.customer.account.api_keys,
    element: <AccountAPIKeysPage />,
    teamMemberRole: [ETeamMemberRole.OWNER],
  },
  {
    path: Routes.customer.account.white_label,
    element: <AccountWhiteLabelPage />,
    teamMemberRole: [ETeamMemberRole.OWNER],
  },
];

const publicRoutes: Array<MyRouteObject> = [
  { path: Routes.customer.account.settings, element: <AccountSettingsPage /> },
  { path: Routes.customer.account.team, element: <AccountTeam /> },
];

export const CustomerRoutes: MyRouteObject = {
  path: Routes.customer.index,
  element: <CustomerModule />,
  role: [ERole.ROLE_CUSTOMER],
  children: [
    { path: Routes.customer.dashboard, element: <CustomerDashboardPage /> },
    { path: Routes.customer.create_qr_code, element: <CreateQRCodePage /> },
    { path: Routes.customer.my_qr_codes.index, element: <MyQrCodesPage /> },
    { path: Routes.customer.my_qr_codes.edit, element: <MyQRCodeEditPage /> },
    // TODO after release
    { path: Routes.customer.analytics.index, element: <AnalyticsPage /> },
    { path: Routes.customer.templates.index, element: <Templates /> },
    { path: Routes.customer.templates.create, element: <CreateTemplatePage /> },
    { path: Routes.customer.templates.edit, element: <EditTemplatePage /> },
    { path: Routes.customer.help, element: <HelpPage /> },
    {
      path: Routes.customer.account.index,
      element: <AccountModule />,
      children: [...publicRoutes, ...ownerOnlyRoutes],
    },
    { path: Routes.customer.success_payment, element: <AccountSuccessPaymentPage /> },

    { index: true, path: '*', element: <TypedNavigate to={Routes.customer.dashboard} /> },
  ],
};
